export default __webpack_public_path__ + "static/media/INSTAGRAM.53baf133.png";